import { Component,OnInit,ChangeDetectionStrategy } from '@angular/core';
import { Router,RouterOutlet } from '@angular/router';
import * as AOS from 'aos';
import { NgxSpinnerComponent } from 'ngx-spinner';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, NgxSpinnerComponent]
})

export class AppComponent implements OnInit {

  constructor(private _router: Router) {
    if (!localStorage.getItem('token')) {
      // Only the bare invite-link page: /pages/contribution/{campaignCode}
      // — anchored so it does NOT match longer paths like
      // /pages/contribution/group/message/:id, which must stay as-is.
      const pat1 = /^\/pages\/contribution\/[a-zA-Z0-9]+(?:[/?#]|$)/;
      const pat2 = /^\/pages\/contribution\/send-message\/[a-zA-Z0-9]+\/\d+/;
      const excludedPat = /^\/pages\/contribution\/group\/message\//;

      const path = window.location.href.replace(location.origin, '');

      if (excludedPat.test(path)) {
        // Standalone top-level route (SendMessageComponent) — keep /pages,
        // no redirect logic applies here.
      } else if (pat2.test(path) || pat1.test(path)) {
        const withoutPages = path.replace('/pages', '');
        const [link, qp] = withoutPages.split('?');

        const queryParams: Record<string, string> = {};
        if (qp) {
          qp.split('&').forEach((item) => {
            const [key, value] = item.split('=');
            queryParams[key] = decodeURIComponent(value ?? '');
          });
        }

        this._router.navigate([link], { queryParams });
      }
    }
  }

  ngOnInit() {
    AOS.init({
      duration: 1200,
    });
  }
}
